import { useAppSelector } from '../../../../../store/hooks';
import { WebGamesTableConfigModel } from './models/web-games-table-config.model';

export const useGetWebGamesSelectors = (): WebGamesTableConfigModel => {
  const webGames = useAppSelector(state => state.webGames.webGames);
  const gamesFilters = useAppSelector(state => state.webGames.filters);
  const isLoading = useAppSelector(state => state.root.isLoading);

  return { gamesFilters, webGames, isLoading };
};
